import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id C55BFF6F-469B-4D28-835B-537BED8DE99D
 * name chart-areaspline-variant
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-areaspline-variant.svg
 * tags
 * - Math 
 */
export const ChartAreasplineVariantIcon = createSvgIcon(<><path d="M22,21H2V3H4V15.54L9.5,6L16,9.78L20.24,2.45L21.97,3.45L22,21Z" /></>, 'ChartAreasplineVariantIcon');
export default ChartAreasplineVariantIcon